var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"button-up"},[_c('b-button',{staticClass:"btn-basic btn-basic-center",attrs:{"variant":"basic"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop.apply(null, arguments)}}},[_c('div',[_c('b-icon-arrow-up',{attrs:{"aria-hidden":"true"}})],1),_vm._v(" retour haut de page ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }